export const CHECK_STATES = {
  PENDING: 'pending',
  CHECKING: 'checking',
  PASS: 'pass',
  FAIL: 'fail',
}

export const SYSTEM_VERIFICATION_COPY = {
  brand: 'Bridge',
  brandSubtitle: 'Enterprise Security Layer',
  title: 'System Verification',
  subtitle: 'Step 2: Validating local environment integrity',
  setupTitle: 'Setup required?',
  setupBody:
    'If the bridge components are not detected, install and run the MMT Desktop Agent. No browser extension is required.',
  setupMacTestingNotice:
    'For macOS testing builds (unsigned), after moving the app to Applications, run this command in Terminal:',
  setupMacTestingCommand:
    'xattr -dr com.apple.quarantine "/Applications/MMT Activity Agent.app"',
  continueLabel: 'Continue to Dashboard',
  startCheckLabel: 'Start Device Access Check',
  retryLabel: 'Retry Verification',
  backToLoginLabel: 'Back to Login',
  waitingDecisionPrompt: 'Please choose Allow or Block in your browser prompt to continue verification.',
  decisionTimeoutGuidance:
    'No permission decision detected yet.\n1. Click the lock/tune icon in the address bar.\n2. Open Site settings -> Local Network Access (or Apps on device).\n3. Click Reset permission, reload, and click Start Device Access Check again.',
  appsPermissionGuidance:
    'Browser Local Network permission is blocked.\n1. Click the lock or tune icon (🔒) in the browser address bar.\n2. Look for "Local network access" or "Apps on device" and set it to Allow.\n3. Click Retry Verification.\nWhy needed: allows Bridge to securely verify your desktop agent on this device.',
  notificationsPermissionGuidance:
    'Browser notification permission is blocked.\n1. Click the lock/tune icon in the address bar.\n2. Open Site settings -> Notifications.\n3. Set Notifications to Allow, then retry verification.',
  macAccessibilityGuidance:
    'macOS Accessibility permission is required for Bridge Agent.\n1. Open Apple Menu  -> System Settings -> Privacy & Security -> Accessibility.\n2. Find MMT Activity Agent and toggle the switch to ON (blue).\n3. If not listed, click +, select MMT Activity Agent from /Applications, and enable it.\n4. Click Retry Verification.',
  windowsSmartScreenGuidance:
    'If Windows Defender SmartScreen appears during installation:\n1. Click "More info".\n2. Click "Run anyway".\n3. The agent will launch and sit in your taskbar system tray.',
  agentNotRunningGuidance:
    'Desktop Agent is not running on this computer.\n1. Download the installer for your operating system below.\n2. Install and launch MMT Activity Agent.\n3. Verify the agent icon appears in your taskbar / menu bar.\n4. Click Retry Verification.',
  versionOutdatedGuidance:
    'Your installed Bridge Agent is outdated.\n1. Download the latest agent v2.1.1 installer below.\n2. Run the installer (it will automatically replace the old version).\n3. Click Retry Verification.',
}

export const STATUS_ITEMS = [
  {
    key: 'browserAccess',
    label: 'Browser Network Access',
    icon: 'lan',
    description: 'Localhost device communication',
  },
  {
    key: 'agentRunning',
    label: 'Desktop Agent Running',
    icon: 'settings_motion_mode',
    description: 'Active on localhost port 4000',
  },
  {
    key: 'versionCheck',
    label: 'Version Compatibility',
    icon: 'update',
    description: 'Agent v2.1.1+ compliance',
  },
  {
    key: 'osPermissions',
    label: 'OS Telemetry Permissions',
    icon: 'admin_panel_settings',
    description: 'Window tracking & Accessibility',
  },
]

export const DOWNLOAD_OPTIONS = [
  { label: 'Windows', icon: 'desktop_windows', href: '/api/activity-monitor/agent-download-file/windows' },
  { label: 'macOS', icon: 'laptop_mac', href: '/api/activity-monitor/agent-download-file/mac' },
]

export const CONNECTION_PARAMETERS = [
  { label: 'Agent Protocol', value: 'v2.1.1-Enterprise' },
  { label: 'Encryption', value: 'HMAC-SHA256' },
  { label: 'Network Policy', value: 'PNA Private Loopback' },
]
